import React from "react";
import { Box } from "../Box";
import { PropLabel } from "../PropX";

type Props =
  | {
      /**
       * A boolean prop that determines whether the block is a fieldset or a div.
       */
      fieldset?: false;
      /**
       * A label for the block. Required if `fieldset` is true.
       */
      label?: PropLabel;
    }
  | {
      /**
       * A boolean prop that determines whether the block is a fieldset or a div.
       */
      fieldset: true;
      /**
       * A label for the block. Required if `fieldset` is true.
       */
      label: PropLabel;
    };

export const CreatePageBlock: React.FC<Props> = (props) => {
  const { children, fieldset = false, label } = props;

  return (
    <Box as={fieldset ? "fieldset" : "div"} display="block" mb={8}>
      {label && PropLabel.renderForBeforeFormSection(label, { as: fieldset ? "legend" : "div" })}
      {children}
    </Box>
  );
};

CreatePageBlock.displayName = "CreatePageBlock";
